// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8d4ab3e6","198":"09fc9a18","445":"b2bf0187","498":"8bef3ec0","703":"8aad03f9","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};